export type SelectAllState = "none" | "some" | "all";

export function selectAll<T>(rows: T[], rowKey: (row: T) => string): Set<string> {
  return new Set(rows.map(rowKey));
}

export function toggle(selected: Set<string>, key: string): Set<string> {
  const next = new Set(selected);
  if (!next.delete(key)) {
    next.add(key);
  }
  return next;
}

export function clear(): Set<string> {
  return new Set();
}

/**
 * Counted over the rows currently on screen rather than over the selected set, so a key left behind
 * by a previous edition cannot push the header checkbox to "all". An empty table reads as "none" —
 * counting it as "all" is the vacuous-truth answer and would render a checked box over no rows.
 */
export function selectAllState<T>(
  selected: Set<string>,
  rows: T[],
  rowKey: (row: T) => string,
): SelectAllState {
  if (rows.length === 0) {
    return "none";
  }

  const selectedOnScreen = rows.filter(row => selected.has(rowKey(row))).length;

  if (selectedOnScreen === 0) {
    return "none";
  }
  return selectedOnScreen === rows.length ? "all" : "some";
}
